/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import PageContainer from '../../../CSIComponents/PageContainer';
import { DownOutlined } from '@ant-design/icons';
import { Card, Button, Modal, Dropdown, Menu } from 'antd';
import { getOTACodes } from '../../../../services/common';
import Loading from '../../../Loading';
import { amenityType, guestroom} from './AmenitiesType'
import { sortHelper } from '../../../../helpers/misc/sortHelper'
import PopUp from '@components/ui/PopUp';
import { deleteHelper, getAllAmenities } from './helpers'

import AnTable from '../../../AnTable';
import AmenityDetail from './AmenityDetail'
import AddModal from './AddModal'
import CreateAmenity from '../CreateAmenity/index'
import { getGuestrooms } from '../Amenities/helpers'

type propTypes= {
    isNewRecordRoom: boolean,
    setOperation: (e: string) => void,
    currentRow: guestroom,
    setCurrentRow: (e: object) => void,
    setAmenitiesToAdd?: (e: {}[]) => void,
    guestroomData?: []
    singleAmenity?: string
    setDefKey: (e: string) => void
    setSingleAmenity?: (e: string) => void
    stay?: boolean
    roomId?: number
    roomLangId?: number
    operationFlag?: string
}

const Amenities = (props: propTypes) => {
    const [editLoading, setEditLoading] = useState(false);
    const [viewOrEdit, setViewOrEdit] = useState(1);
    const dataListTab = props.currentRow && props.currentRow.amenities && props.currentRow.amenities.length > 0 ? props.currentRow.amenities : [];
    const [dataSource, setDataSource] = useState<amenityType[]>(dataListTab);
    const [selectedTagsData, setSelectedTagsData] = useState<Array<object>>([]);
    const [typeData, setTypeData] = useState<Array<{key:string, codeName: string}>>([]);
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState<string>('')
    const [ detailViewOn, setDetailViewOn] = useState<boolean>(false)
    const [ singleAmenity, setSingleAmenity] = useState<amenityType | object>({})
    const [isOnEditMode, setIsOnEditMode] = useState<boolean>(false)
    const [guestRoomAllAmenities, setGuestRoomAllAmenities] = useState([])
    const [existingGuestRoomAllAmenities, setExistingGuestRoomAllAmenities] = useState([])

    //Amenities(Drop Down): type
    const getTypeData = async () => {
        let res = await getOTACodes('RMA', '')
        if (res && res.otacodes && res.otacodes.length !== 0) {
            res.otacodes.map((item: {key:string, codeName: string}) => item.key = item.codeName)
            setTypeData(res.otacodes)
        } else {
            setTypeData([])
        }
    };
    // Amenities(transfer):Selected Tags
    const getSelectedTags = async () => {
        let res = await getOTACodes('TAG', '')
        if (res && res.otacodes && res.otacodes.length !== 0) {
            res.otacodes.map((item: {key:string, codeName: string}) => item.key = item.codeName)
            setSelectedTagsData(res.otacodes)
        } else {
            setSelectedTagsData([])
        }
    };

    const back = () => {
        setViewOrEdit(1)
        props.setOperation('table')
    }

    const getGuestRoomsData = useCallback(async () => {
    const { property: { guestrooms: { guestroom }}} = await getGuestrooms()
        if (props.currentRow.grid) {
            const [filteredRoom] = guestroom.filter(({ grid } : { grid: number}) => grid === props.currentRow.grid )
            setDataSource(filteredRoom?.amenities)
        }
    }, [])

    const getGuestRoomsDataForAddition = useCallback(async (guestroomrid: number) => {
        const { property: { guestrooms: { guestroom }}} = await getGuestrooms()
        const [filteredRoom] = guestroom.filter(({ grid } : { grid: number}) => grid === guestroomrid )
        console.log(filteredRoom)
        setDataSource(filteredRoom?.amenities)
        }, [])

    const getAll = useCallback(async () => {
        try {
          if (props.currentRow && props.currentRow.grid) {
            const { grid } = props.currentRow
            const data: any = await getAllAmenities(grid)
            setGuestRoomAllAmenities(data.guestRoomAllAmenities)
            getGuestRoomsData()
          }
        } catch (error) {
          throw error
        }
    },[props.currentRow])

     const reload = async () => {
         if (props.stay && props.roomId) {
            const data: any = await getAllAmenities(props.roomId)
            const filteredData = data.guestRoomAllAmenities.filter(({ selected } : { selected: boolean }) => selected)
            setDataSource(filteredData)
         } else {
            return !props.stay && back()
         }
     }

    const getExistingAmenities = async () => {
        if (props.roomId !== undefined) {
            const data: any = await getAllAmenities(props.roomId)
            setExistingGuestRoomAllAmenities(data.guestRoomAllAmenities)
            setMode('Existing'); 
            setVisible(true);
        }
    }

    useEffect(() => {
        getTypeData();
        getSelectedTags();
        getAll();
    }, [])

    useEffect(() => {
        detailViewOn === false && setSingleAmenity({})
    }, [detailViewOn])

    useEffect(() => {
        if (props.currentRow?.amenities) {
            if (props.singleAmenity !== undefined && typeof (props.singleAmenity) === 'string' && props.currentRow) {
                // @ts-expect-error
                const [single] = props.currentRow.amenities.filter(({ type } : {type: string}) => (props.singleAmenity?.toLowerCase() === type?.toLowerCase()))
                setMode('Edit'); 
                setDetailViewOn(true)
                setSingleAmenity(single)
            }
        }
    }, [props])

    const update = (roomUpdated: {amenities: amenityType[]}) => {
        setDataSource(roomUpdated.amenities);
        props.setCurrentRow(roomUpdated)
        setViewOrEdit(1)
        props.setOperation('view')
        setEditLoading(false)
    }

    const getLocalId = (amenity: amenityType) => {
        let existing : object | undefined = {}
        while (existing) {
            amenity.amenityid = Math.random()
            existing = dataSource.find((item) => item.amenityid === amenity.amenityid)
        }
        return amenity
    }

    const localManagment = (amenity: amenityType, action: string) => {
        let tempAmenities = dataSource
        switch (action) {
            case 'Add':
                tempAmenities.push(getLocalId(amenity))
                break;
            case 'Edit':
                for(let i = 0; i < tempAmenities.length; i++){
                    if (tempAmenities[i].amenityid === amenity.amenityid) {
                        tempAmenities[i] = amenity
                        break;
                    } 
                }
                break;
            case 'Delete':
                for(let i = 0; i < tempAmenities.length; i++){
                    if (tempAmenities[i].amenityid === amenity.amenityid) {
                        tempAmenities.splice(i, 1);
                        break;
                    } 
                }
                break;
            default: break;
        }
        setDataSource(tempAmenities)
        setDetailViewOn(false)
        props.setAmenitiesToAdd && props.setAmenitiesToAdd(tempAmenities)
    }

    if (editLoading) {
        return <Loading type="large" />
    }

    const ModalHead = () => {
        return (
            <div className='modalHead'>Confirm</div>
        )
    }

    const ViewAmenity = (e:React.MouseEvent)=>{
        e.stopPropagation();
        const record: any = window.sessionStorage.getItem('popUpData')
        setSingleAmenity(JSON.parse(record))
        setMode('View'); 
        setDetailViewOn(true)
        setIsOnEditMode(false)
        return;
    }

    const EditAmenity = (e:React.MouseEvent)=>{
        e.stopPropagation();
        const record: any = window.sessionStorage.getItem('popUpData')
        const recordData = JSON.parse(record)
        const [filteredData] = dataSource.filter((item: any) => item.type === recordData.type)
        setSingleAmenity(filteredData)
        setMode('Edit'); 
        setDetailViewOn(true)
        setIsOnEditMode(true)
    }

    const DeleteAmenity = (e: React.MouseEvent) => {
        e.stopPropagation();
        Modal.confirm({
            title: <ModalHead />,
            centered: true,
            icon: '',
            content: `Are you sure you want to remove this amenity?`,
            cancelText: 'Cancel',
            okText: 'Delete',
            async onOk() {
                const data: string | any = window.sessionStorage.getItem('popUpData')
                const { amenityid, amenitylangid } = JSON.parse(data)
                const { grid, grlangid } = props.currentRow
                const body = {
                    guestroom:[
                        {
                           grid,
                           grlangid,
                           amenities:[
                              {
                                 amenityid,
                                 amenitylangid
                              }
                           ]
                        }
                     ]
                }
                const remove: any = await deleteHelper('/property/guestroom/amenities', body)
                const { property: { guestrooms : { guestroom } }} = remove
                const [filteredGuestRoom] = guestroom.filter((guest: { grid: number }) => guest.grid === grid)
                return setDataSource(filteredGuestRoom.amenities)
            }
        });
    }

    const onClose = () => {
        setVisible(false);
    };
      
    const menu = (
        <Menu>
          <Menu.Item>
            <a
              onClick={() => {
                setMode('Add'); 
                setVisible(true);
            }}
            >
              Create A New Amenity
            </a>
          </Menu.Item>
          <Menu.Item>
            <a
            onClick={() => {
                getExistingAmenities()
            }}
            >
              Add Existing Amenities
            </a>
          </Menu.Item>
        </Menu>
      );

      const ButtonIcon3 = (props: any) => {
        return <Button 
        style={{ background: '#004771', color: '#fff', width: 80, height: 28 }} 
        {...props}
        >
            Add
            <DownOutlined />
        </Button>;
      };

    const dropBUtton = () => (
        <Dropdown overlay={menu}>
          <ButtonIcon3></ButtonIcon3>
        </Dropdown>
    )

    return (
    <> 
        <PageContainer>
            { !detailViewOn &&
                <Card style={{ marginTop: -15, marginBottom:65 }}>
                <div>
                    <div className="col-12">
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {/* CNT-2340
                            <Button style={{ background: '#004771', color: '#fff', width: 60, height: 28, marginRight: '8px' }} 
                                onClick={back}>
                                    Back
                            </Button> 
                            amenityType
                            */}
                            {
                                props.operationFlag !== 'add' && <Button style={{ background: '#004771', color: '#fff', width: 60, height: 28 }} 
                                    onClick={() => {
                                        setMode('Existing'); 
                                        setVisible(true);
                                    }}>
                                        Add
                                </Button>
                            }
                            { 
                                props.operationFlag === 'add' && dropBUtton()
                            }
                        </div>
                    </div>

                    <div className="col-12">
                        <AnTable
                                data = {dataSource}
                                configuration = {[
                                    {
                                        title: '',
                                        key: 'index',
                                        render: (text: string, record: [], index: number) => index += 1,
                                        width: '40px'
                                    },
                                    { 
                                        title: 'Amenity Name', 
                                        dataIndex: 'type', 
                                        key: 'type',
                                        sorter: (a: [], b: []) => sortHelper(a, b, 'type'),
                                        showSorterTooltip: false,
                                        onCell: (e: any) => {
                                            return {
                                                onClick: () => {
                                                    setSingleAmenity(e)
                                                    setMode('Edit'); 
                                                    setDetailViewOn(true)
                                                },
                                            };
                                        },
                                        render: (text: string) => (
                                            <>
                                                <span style={{ color: '#06789D', cursor: 'pointer' }}>
                                                    {text}
                                                </span>
                                            </>
                                        )
                                    },
                                    { 
                                        title: 'Amenity ID', dataIndex: props.operationFlag !== 'add' ? 'id' : 'identity', 
                                        key: props.operationFlag !== 'add' ? 'id' : 'identity',
                                        sorter: (a: [], b: []) => sortHelper(a, b, 'id'),
            showSorterTooltip: false
                                    },
                                    { 
                                        title: 'Amenity Detail', dataIndex: 'details', 
                                        key: 'details',
                                        sorter: (a: [], b: []) => sortHelper(a, b, 'details'),
            showSorterTooltip: false
                                    },
                                    { 
                                        title: 'Included in Rate', dataIndex: 'includedinrate', key: 'includedinrate',
                                        sorter: (a: [], b: []) => sortHelper(a, b, 'includedinrate'),
            showSorterTooltip: false
                                    },
                                    { 
                                        title: 'Quantity', dataIndex: 'quantity', 
                                        key: 'quantity',
                                        sorter: (a: [], b: []) => sortHelper(a, b, 'quantity'),
            showSorterTooltip: false
                                    },
                                    { 
                                        title: 'Description', dataIndex: 'description', key: 'description',
                                        sorter: (a: [], b: []) => sortHelper(a, b, 'description'),
            showSorterTooltip: false
                                    },
                                    {
                                        title: 'Action',
                                        dataIndex: 'action',
                                        key: 'action',
                                        align: 'center' as 'center',
                                        render:(text: string, record: [], index: number)=>(
                                            <PopUp 
                                            trigger='click'
                                            color='white'
                                            placement="bottomRight"
                                            data={props.currentRow}
                                            opts={
                                                [
                                                    {title:'View', action:ViewAmenity, data: record},
                                                    {title:'Edit', action:EditAmenity, data: record},
                                                    {title:'Delete', action:DeleteAmenity,
                                                    data: record},
                                                ]
                                            } />
                                        )
                                    },
                                ]}
                                onCLickRow = {(e) => e }
                                search= {{label: 'Search', placeholder: 'Search Amenities'}}
                                />
                    </div>
                </div>
                </Card>
            }
            {
                mode === 'Existing' && visible && guestRoomAllAmenities.length > 0 && props.currentRow !== undefined &&
                <AddModal
                  visible={visible}
                  loading={loading}
                  setVisible={setVisible}
                  currentRow={props.currentRow}
                  setDataSource={setDataSource}
                  getGuestRoomsData={getGuestRoomsData}
                />
            }
            {
                mode === 'Existing' && visible && existingGuestRoomAllAmenities.length > 0 &&
                <AddModal
                  visible={visible}
                  loading={loading}
                  setVisible={setVisible}
                  // @ts-ignore
                  currentRow={{ grid: props.roomId, grlangid: props.roomLangId }}
                  setDataSource={setDataSource}
                  getGuestRoomsDataForAddition={getGuestRoomsDataForAddition}
                />
            } 
            {
                mode === 'Add' &&
                <CreateAmenity
                    onClose={onClose}
                    visible={visible}
                    setOperation={props.setOperation}
                    setCurrentRow={props.setCurrentRow}
                    setDefKey={props.setDefKey}
                    setSingleAmenity={props.setSingleAmenity}
                    reload={reload}
                />
            }
            {
                detailViewOn && (mode === 'Edit' || mode === 'View') &&
                <AmenityDetail 
                    typeData = {typeData}
                    singleAmenity = {singleAmenity}
                    mode = {mode}    
                    isNewRecordRoom = {props.isNewRecordRoom}
                    setDetailViewOn = {setDetailViewOn} 
                    guestroom = {props.currentRow}
                    setEditLoading = {setEditLoading}
                    update = { update }
                    localManagment = {localManagment}
                    isOnEditMode={isOnEditMode}
                />
            }
            
        </PageContainer>
        </>
    )
}

export default Amenities;
